<template>
  <div class="modal-body-traducoes">
    <div
      class="modal-traducao-container base animate__animated animate__bounceInDown animate__delay-0.5s"
    >
      <div class="modal-traducao-container1">
        <CloseIcon @action="closeModal" />
      </div>
      <div class="modal-traducao-container2">
        <!-- DESCRICAO DE CATEGORIAS -->
        <div
          v-if="$config.traducao_item == 'categorias_descricao'"
          class="modal-traducao-container3"
        >
          <div class="modal-traducao-container5">
            <label class="input-labels">Descrição inglês</label>
            <v-text-field
              solo
              placeholder="Insira a tradução"
              v-model="$produtos_categorias.cadastro.descricao_en_us"
              @input="$produtos_categorias.cadastro.error.descricao_en_us = []"
              type="text"
              class="modal-traducao-textinput"
              :error-messages="
                $produtos_categorias.cadastro.error.descricao_en_us
              "
            ></v-text-field>
          </div>
          <div class="modal-traducao-container5">
            <label class="input-labels">Descrição espanhol</label>
            <v-text-field
              solo
              placeholder="Insira a tradução"
              v-model="$produtos_categorias.cadastro.descricao_es_es"
              @input="$produtos_categorias.cadastro.error.descricao_es_es = []"
              type="text"
              class="modal-traducao-textinput"
              :error-messages="
                $produtos_categorias.cadastro.error.descricao_es_es
              "
            ></v-text-field>
          </div>
        </div>
        <!-- DESCRITIVO DE CATEGORIAS -->
        <div
          v-else-if="$config.traducao_item == 'categorias_descritivo'"
          class="modal-traducao-container3"
        >
          <div class="modal-traducao-container6">
            <label class="input-labels">Descritivo inglês</label>
            <v-textarea
              solo
              name="input-7-4"
              rows="3"
              placeholder="Insira a tradução"
              no-resize
              class="modal-traducao-textarea"
              v-model="$produtos_categorias.cadastro.descritivo_en_us"
            >
            </v-textarea>
          </div>
          <div class="modal-traducao-container6">
            <label class="input-labels">Descritivo espanhol</label>
            <v-textarea
              solo
              name="input-7-4"
              rows="3"
              placeholder="Insira a tradução"
              no-resize
              class="modal-traducao-textarea"
              v-model="$produtos_categorias.cadastro.descritivo_es_es"
            >
            </v-textarea>
          </div>
        </div>
        <!-- PERGUNTA DE PERGUNTAS FREQUENTES -->
        <div
          v-else-if="$config.traducao_item == 'perguntas_frequentes_pergunta'"
          class="modal-traducao-container3"
        >
          <div class="modal-traducao-container6">
            <label class="input-labels">Pergunta inglês</label>
            <v-textarea
              solo
              name="input-7-4"
              rows="3"
              placeholder="Insira a tradução"
              no-resize
              class="modal-traducao-textarea"
              v-model="$loja_gerenciar.question.pergunta_en_US"
            >
            </v-textarea>
          </div>
          <div class="modal-traducao-container6">
            <label class="input-labels">Pergunta espanhol</label>
            <v-textarea
              solo
              name="input-7-4"
              rows="3"
              placeholder="Insira a tradução"
              no-resize
              class="modal-traducao-textarea"
              v-model="$loja_gerenciar.question.pergunta_es_ES"
            >
            </v-textarea>
          </div>
        </div>
        <!-- RESPOSTA DE PERGUNTAS FREQUENTES -->
        <div
          v-else-if="$config.traducao_item == 'perguntas_frequentes_resposta'"
          class="modal-traducao-container3"
        >
          <div class="modal-traducao-container6">
            <label class="input-labels">Resposta inglês</label>
            <vue-editor
              v-model="$loja_gerenciar.question.resposta_en_US"
              placeholder="Insira a resposta"
              class="lojas-gerenciar-tema-container-text-imagem-input"
              :editor-toolbar="customToolbar"
            >
            </vue-editor>
          </div>
          <div class="modal-traducao-container6">
            <label class="input-labels">Resposta espanhol</label>
            <vue-editor
              v-model="$loja_gerenciar.question.resposta_es_ES"
              placeholder="Insira a resposta"
              class="lojas-gerenciar-tema-container-text-imagem-input"
              :editor-toolbar="customToolbar"
            >
            </vue-editor>
          </div>
        </div>
        <!-- DESCRICAO DE PRODUTO -->
        <div
          v-else-if="$config.traducao_item == 'produto_descricao'"
          class="modal-traducao-container3"
        >
          <div class="modal-traducao-container5">
            <label class="input-labels">Descrição inglês</label>
            <v-text-field
              solo
              placeholder="Insira a tradução"
              v-model="
                $produtos_gerenciar.cadastro.dados_cadastrais.descricao_en_us
              "
              type="text"
              class="modal-traducao-textinput"
              counter="65"
              :rules="rulesDescricao"
            >
            </v-text-field>
          </div>
          <div class="modal-traducao-container5">
            <label class="input-labels">Descrição espanhol</label>
            <v-text-field
              solo
              placeholder="Insira a tradução"
              v-model="
                $produtos_gerenciar.cadastro.dados_cadastrais.descricao_es_es
              "
              type="text"
              class="modal-traducao-textinput"
              counter="65"
              :rules="rulesDescricao"
            >
            </v-text-field>
          </div>
        </div>
        <!-- DESCRITIVO DE PRODUTO -->
        <div
          v-else-if="$config.traducao_item == 'produto_descritivo'"
          class="modal-traducao-container3"
        >
          <div class="modal-traducao-container6">
            <label class="input-labels">Descritivo inglês</label>
            <v-textarea
              solo
              name="input-7-4"
              rows="3"
              placeholder="Insira a tradução"
              no-resize
              class="modal-traducao-textarea"
              counter="1500"
              :rules="rulesDescritivo"
              v-model="
                $produtos_gerenciar.cadastro.dados_cadastrais.descritivo_en_us
              "
            ></v-textarea>
          </div>
          <div class="modal-traducao-container6">
            <label class="input-labels">Descritivo espanhol</label>
            <v-textarea
              solo
              name="input-7-4"
              rows="3"
              placeholder="Insira a tradução"
              no-resize
              class="modal-traducao-textarea"
              counter="1500"
              :rules="rulesDescritivo"
              v-model="
                $produtos_gerenciar.cadastro.dados_cadastrais.descritivo_es_es
              "
            ></v-textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
export default {
  name: "ModalTraducoes",
  components: {
    VueEditor,
    CloseIcon: () => import("@/components/icons/CloseIcon.vue"),
  },
  data() {
    return {
      rulesDescricao: [
        v =>
          v.length <= 65 ||
          "A descrição do produto não pode ter mais de 65 caracteres!",
      ],
      rulesDescritivo: [
        v =>
          v.length <= 1500 ||
          "O descritivo do produto não pode ter mais de 1500 caracteres!",
      ],
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        ["code-block", "link"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        ["blockquote"],
        ["clean"], // remove formatting button
      ],
    };
  },
  methods: {
    closeModal() {
      document.getElementsByClassName("modal-body-traducoes")[0].style.display =
        "none";
    },
  },
};
</script>

<style scoped>
.modal-body-traducoes {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 999999999;
  /* Sit on top */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
  justify-content: center;
  align-items: center;
}

.modal-traducao-container {
  width: 780px;
  height: 580px;
  display: flex;
  position: relative;
  align-items: center;
  padding: 0.0825rem;
  border-radius: 1.365rem;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #eaeaea;
}

.modal-traducao-container1 {
  width: 100%;
  height: 5%;
  display: flex;
  justify-content: flex-end;
  padding: 0.325rem;
}

.modal-traducao-icon {
  width: 24px;
  height: 24px;
  margin-top: 0.1875rem;
  margin-right: 0.375rem;
}

.modal-traducao-icon:hover {
  width: 26px;
  height: 26px;
  cursor: pointer;
  fill: var(--dl-color-gray-white);
}

.modal-traducao-container2 {
  flex: 0 0 auto;
  width: 100%;
  height: 90%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 15px 15px;
  overflow: auto;
}

.modal-traducao-container3 {
  width: 100%;
  height: 100%;
  overflow: none;
}

.modal-traducao-container5 {
  flex: 0 0 auto;
  width: 100%;
  height: 105px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  padding: 0px 10px;
}

.modal-traducao-container6 {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  padding: 0px 0px;
}

.modal-traducao-textinput {
  width: 100%;
  height: 51px;
  border-radius: 10px;
}

.modal-traducao-textarea {
  width: 100%;
  height: 124px !important;
  max-height: 124px !important;
  border-width: 0px;
  border-radius: 10px;
}

.lojas-gerenciar-tema-container-text-imagem-input {
  height: auto;
  width: 100%;
  overflow: auto;
  margin-top: 0.375rem;
  margin-bottom: 0.625rem;
  background: #fff;
  border-top-left-radius: 1.25rem;
  border-top-right-radius: 1.25rem;
  border-bottom-left-radius: 1.25rem;
  border-bottom-right-radius: 1.25rem;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  -webkit-box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}
</style>
